import { EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import { brandUuid } from 'src/app/core/store/brands/brands.selectors';
import { MultiStepFormComponent } from 'src/app/shared/components/multi-step-form/multi-step-form.component';

@UntilDestroy()
export abstract class MultiStepFormStep implements OnInit {
  abstract multiStepForm: MultiStepFormComponent;
  stepForm: FormGroup;
  abstract isLoading: boolean;
  @Output() protected onStepFormChange: EventEmitter<any>;
  protected _brandId: string;

  protected get brandId(): string {
    return this._brandId;
  }

  protected set brandId(brandId: string) {
    this._brandId = brandId;
  }

  constructor(protected fb: FormBuilder, protected store: Store) {}

  ngOnInit(): void {
    this.store
      .pipe(select(brandUuid), untilDestroyed(this))
      .subscribe((brandId: string) => {
        this.brandId = brandId;
      });
  }
}
